export const setCloseSession = (value) => ({
    type: 'SET_CLOSE_SESSION',
    payload: value,
  });